import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth.js';
import { SignIn } from './components/SignIn.js';
import { Topbar } from './components/Topbar.js';
import { Home } from './routes/Home.js';
import { Dashboard } from './routes/Dashboard.js';
import { Lesson } from './routes/Lesson.js';
import { QA } from './routes/QA.js';
import { QADetail } from './routes/QADetail.js';

export function App() {
  const { state } = useAuth();

  if (state.status === 'loading') {
    return (
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
        <div className="eyebrow">▌ Loading…</div>
      </div>
    );
  }

  if (state.status === 'signed-out') {
    return <SignIn />;
  }

  return (
    <>
      <Topbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/lesson/:slug" element={<Lesson />} />
        <Route path="/qa" element={<QA />} />
        <Route path="/qa/:id" element={<QADetail />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
